<template>
    <div class="fee-list-table">
        <b-table v-if="fees.length" :fields="fields" :items="tableItems" responsive striped>
            <template v-slot:table-colgroup="scope">
                <col
                    v-for="field in scope.fields"
                    :key="field.key"
                    :style="{ width: field.width ?? 'auto' }">
            </template>
            <template v-slot:cell(amountPaid)="data">
                <span :class="getAmountPaidClasses(data.item.amountPaid)">
                    <template v-if="data.item.hasAmountAdjustmentGross">*&nbsp;</template>{{ data.value }}
                </span>
            </template>
            <template v-slot:cell(amountOpen)="data">
                <span :class="getAmountOpenClasses(data.item.amountOpen)">
                    {{ data.value }}
                </span>
            </template>
            <template v-slot:cell(paymentComment)="data">
                <span style="white-space: pre-wrap">{{ data.value }}</span>
            </template>
            <template v-slot:cell(actions)="data">
                <div class="table-actions mb-2" style="text-align: left">
                    <a href="#" title="Details anzeigen"
                        @click.prevent="$emit('fee-details', data.item.id)">
                        <i class="inticon-autoclaim_detail"/>
                    </a>
                    <a v-if="data.item.permissions.canEdit" href="#" title="Bearbeiten"
                        @click.prevent="$emit('fee-edit', data.item.id)">
                        <i class="inticon-autoclaim_bearbeiten"/>
                    </a>
                    <a v-if="data.item.permissions.canDelete" href="#" title="Löschen"
                        @click.prevent="$emit('fee-delete', data.item.id)">
                        <i class="inticon-autoclaim_loschen"/>
                    </a>
                </div>
            </template>
        </b-table>
        <b-alert v-if="fees.length === 0" show variant="info">
            Keine Kostennoten vorhanden.
        </b-alert>
    </div>
</template>

<script>
    import {emptyValuePlaceholder, formatCurrencyCents} from '@js/functions/format';
    import {formatDate} from '@js/functions/date';

    export default {
        props: {
            fees: {
                type: Array,
                required: true,
            },
        },
        emits: ['fee-delete', 'fee-details', 'fee-edit'],
        data() {
            return {
                fields: [
                    {
                        key: 'receipt',
                        label: 'Rechnungsnr.',
                        formatter: emptyValuePlaceholder,
                        width: '120px',
                    },
                    {
                        key: 'feeText',
                        label: 'Bezeichnung',
                    },
                    {
                        key: 'dateReceipt',
                        label: 'RE-Datum',
                        width: '95px',
                        formatter: formatDate,
                    },
                    {
                        key: 'amountNet',
                        label: 'Forderung (netto)',
                        width: '140px',
                        formatter: formatCurrencyCents,
                    },
                    {
                        key: 'amount',
                        label: 'Forderung (brutto)',
                        width: '140px',
                        formatter: formatCurrencyCents,
                    },
                    {
                        key: 'datePaid',
                        label: 'bezahlt am',
                        width: '95px',
                        formatter: formatDate,
                    },
                    {
                        key: 'amountPaid',
                        label: 'Zahlung',
                        width: '140px',
                        formatter: formatCurrencyCents,
                    },
                    {
                        key: 'amountOpen',
                        label: 'Differenz',
                        width: '140px',
                        formatter: formatCurrencyCents,
                    },
                    {
                        key: 'paymentComment',
                        label: 'Bemerkung',
                        width: '150px',
                        formatter: emptyValuePlaceholder,
                    },
                    {
                        key: 'actions',
                        label: 'Aktionen',
                        thClass: 'text-right',
                        tdClass: 'text-right',
                        width: '90px',
                        formatter: emptyValuePlaceholder,
                    },
                ],
            };
        },
        computed: {
            tableItems() {
                const tableItems = [];

                this.fees.forEach((item) => {
                    tableItems.push(
                        {
                            id: item.id,
                            ...item.attributes,
                            ...item.meta,
                        }
                    );
                });

                return tableItems;
            },
        },
        methods: {
            emptyValuePlaceholder,
            formatCurrencyCents,
            formatDate,
            getAmountPaidClasses(amountPaid) {
                const classes = [];
                if (amountPaid > 0) {
                    classes.push('text-success');
                }
                return classes;
            },
            getAmountOpenClasses(amountOpen) {
                const classes = [];
                if (amountOpen > 0) {
                    classes.push('text-danger');
                }
                return classes;
            },
        },
    }
</script>
